import React from 'react';
import Navbar from '../components/Navbar/Navbar';
import AboutBanner from '../sections/AboutBanner/AboutBanner';

const About = () => {
    return (
        <>
            <Navbar />
            <AboutBanner />
        </>
    );
};

export default About;